import React, { Component } from "react";

import { SamplingSitesContextProvider } from "./context/sampling-sites-context";
import AsyncComponent from "../../../components/async-component";
import { updateBreadcrumb } from "../../../utils/breadcrumbs";
import PageContent from "../../../components/page-content";
import PageWrap from "../../../components/page-wrap";

class BSSamplingSites extends Component {
    componentDidMount = updateBreadcrumb;

    render() {
        return (
            <PageWrap>
                <PageContent>
                    <SamplingSitesContextProvider>
                        <AsyncComponent component={() => import("./content")} />
                    </SamplingSitesContextProvider>
                </PageContent>
            </PageWrap>
        );
    }
}

export default BSSamplingSites;
